// FAQ knowledge entries: question/answer pairs stored as plain text,
//
//   Q: Do you offer refunds?
//   A: Yes, within 30 days.
//
//   Q: …
//
// so an entry stays human-readable and editable as text, while the chunker can
// index each pair as its own chunk: a visitor's question then retrieves the
// exact answer instead of a window that happens to contain three of them.
// Shared: the server chunks and validates with it, the admin FAQ editor
// round-trips its question/answer list through it. Pure (see faq.test.ts).

export interface FaqPair {
  question: string;
  answer: string;
}

export const MAX_FAQ_PAIRS = 500;

/** Parse "Q: … / A: …" blocks. Answers may span lines and paragraphs. */
export function parseFaq(content: string): FaqPair[] {
  const pairs: FaqPair[] = [];
  // A new pair starts at a line beginning with "Q:".
  for (const block of content.replace(/\r\n?/g, '\n').split(/\n(?=\s*Q:)/i)) {
    const match = /^\s*Q:\s*([\s\S]*?)\n\s*A:\s*([\s\S]*)$/i.exec(block);
    if (!match) continue;
    const question = match[1]!.replace(/\s+/g, ' ').trim();
    const answer = match[2]!.trim();
    if (question && answer) pairs.push({ question, answer });
  }
  return pairs;
}

/** Canonical text form of a list of pairs. */
export function formatFaq(pairs: FaqPair[]): string {
  return pairs.map((p) => `Q: ${p.question.trim()}\nA: ${p.answer.trim()}`).join('\n\n');
}
